// Types
import { FeatureFlagType } from 'types/feature-flag.type';

const isFeatureFlagsLegitApiResponse = (
  response: FeatureFlagType[] | { [key: string]: never }
): boolean =>
  response &&
  response?.length > 0 &&
  response.every((flag: FeatureFlagType) => 'flagName' in flag && 'isEnabled' in flag);

export { isFeatureFlagsLegitApiResponse };
